export enum FilterType {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
